/**
 * 定义全局函数，或者单独引用
 * */
import { ROLE_TYPE, FIX_DATE_MAP } from '@/config/constants.js'
/**
 * 微信浏览器中设置对应页面的标题
 * 解决：IOS微信浏览器中用document.title 设置标题无效
 * */
export const setTitle = title => {
  document.title = title
  let iframe = document.createElement('iframe')
  iframe.setAttribute(
    'src',
    'https://sh.51youdian.com/Public/Index/images/navbar/nav-logo.png'
  )
  iframe.setAttribute('style', 'display:none')
  iframe.addEventListener('load', () => {
    setTimeout(() => {
      try {
        iframe.removeEventListener('load')
      } catch (err) {}
      document.body.removeChild(iframe)
    }, 0)
  })
  try {
    document.body.appendChild(iframe)
  } catch (err) {}
}

/**
 * 对象的深拷贝
 * @param source 需要深拷贝的对象
 * @returns {object}
 */
export const objDeepCopy = source => {
  let sourceCopy = {}
  for (let item in source) {
    sourceCopy[item] =
      typeof source[item] === 'object'
        ? objDeepCopy(source[item])
        : source[item]
  }
  return sourceCopy
}

/**
 * 对象数组的深拷贝
 * @param source 需要深拷贝的对象
 * @returns {object}
 */
export const objArryDeepCopy = source => {
  let sourceCopy = source instanceof Array ? [] : {}
  for (let item in source) {
    sourceCopy[item] =
      typeof source[item] === 'object'
        ? objArryDeepCopy(source[item])
        : source[item]
  }
  return sourceCopy
}

/**
 * 判断手机是android 还是 ios
 * */
export const mobileVersion = () => {
  let u = navigator.userAgent
  let isAndroid
  let isIos
  isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  isIos = !!u.match(/\(i[^]+( U)? CPU.+Mac OS X/) // ios终端

  if (isAndroid) {
    return 'android'
  } else if (isIos) {
    return 'ios'
  } else {
    return 'windows'
  }
}

/**
 * 随机码 对指定的字符串中随机取参数位
 */
export const randomString = len => {
  len = len || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

/**
 * 获取文件后缀
 */
export const getSuffix = filename => {
  let pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos !== -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

export const base64toFile = (dataurl, filename) => {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  // return new File([u8arr], filename, { type: mime })
  return new Blob([u8arr], { type: mime })
}

/**
 * 时间戳转时间
 * @param val 传入的时间挫
 * @param type 需要转换的类型  YYYY-MM-DD ： 只需要日期 ； YYYY-MM-DD HH:MM:SS ： 日期加时分秒
 * 如只需要如期，则startNum ： 0 ， endNum ： 10
 */
export const transitionTimestamp = (val, type) => {
  let date
  if (typeof val === 'number') {
    val = val * 1 < 100000000000 ? val * 1000 : val // 当不是毫秒时候，转换为毫秒
    date = new Date(val)
  } else if (typeof val === 'object') {
    date = val // val是Date对象
  } else if (typeof val === 'string') {
    date = new Date(val.replace(/-/g, '/')) // val是入2019-09-09字符串
  }

  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  const hour = ('0' + date.getHours()).slice(-2)
  const minute = ('0' + date.getMinutes()).slice(-2)
  const second = ('0' + date.getSeconds()).slice(-2)
  let format = ''
  switch (type) {
    case 'YYYY-MM-DD':
      format = `${year}-${month}-${day}`
      break
    case 'HH:MM:SS':
      format = `${hour}:${minute}:${second}`
      break
    case 'YYYY-MM-DD hh:mm':
      format = `${year}-${month}-${day} ${hour}:${minute}`
      break
    case 'MM-DD hh:mm':
      format = `${month}-${day} ${hour}:${minute}`
      break
    default:
      format = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      break
  }
  return format
}
export function getTime6MonthLater (data, type = 'YYYY-MM-DD') {
  let year = data.getFullYear()
  let month = data.getMonth() + 7
  let day = data.getDate()
  if (month > 12) {
    month -= 12
    year++
  }
  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day
  return transitionTimestamp(new Date(`${year}/${month}/${day}`), type)
}
/**
 * @function 节流防抖函数
 * @author xuchen
 * @param {Function} fn 需要执行的函数
 * @param {Number} delay 延迟执行的事件
 * @return void
 */
export const throttle = function (fn, delay) {
  let last = 0 // 最后一次执行的时间
  let timer = null // 定时器
  return function () {
    let self = this
    let args = arguments
    let now = Date.now()
    if (now - last >= delay) {
      last = now
      fn.apply(self, args)
    } else {
      clearTimeout(timer)
      timer = setTimeout(() => {
        last = now
        fn.apply(self, args)
      }, delay)
    }
  }
}
/**
 * 函数防抖
 * @param func 函数
 * @param delay 延迟执行毫秒数
 */
export const debounce = function (func, delay) {
  let timer

  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}
/**
 * @function 深拷贝,不考虑函数方法
 * @author xuchen
 * @param {Object} 需要拷贝的对象
 * @param {WeakMap} hash 用来缓存已经拷贝的对象, 避免对象间循环引用问题;
 * @return cloneObj
 */
export const cloneDeep = function(value, hash = new WeakMap()) {
  if (value === null || value === undefined) return value
  if (typeof value !== 'object') return value
  if (value instanceof Date) return new Date(value)
  if (value instanceof RegExp) return new RegExp(value)
  // 此时就应该是 Object 或者 Array 类型
  let instance = new value.constructor() // 实例化当前的对象, 作为新值
  // 避免重复拷贝, 在 WeakMap 中缓存
  if (hash.has(value)) {
    return hash.get(value)
  }
  // 因为 instance 是一个引用类型, 他们在内存空间的地址是同一块, 所以后面赋值的时候也会保存
  hash.set(value, instance)
  for (let key in value) {
    // 利用递归实现深拷贝
    instance[key] = cloneDeep(value[key], hash)
  }
  return instance
}

/**
 * @author lwq
 * @param {Number} num 要处理的数据
 * @param {Number} storeNum 要保留的位数
 */
export const addZeroFormNum = function (num, storeNum = 2) {
  let numArr = String(num).split('.')
  if (!numArr[1]) {
    return num + '.00'
  }
  let addStr = '000000000000000000000'.substring(0, storeNum - numArr[1])
  if (numArr[1].length < storeNum) {
    return num + addStr
  }
  return num
}

/**
 * @author lwq
 */
export const isBoss = function () {
  let curRoleType = Number(sessionStorage.getItem('roleType'))
  return curRoleType === ROLE_TYPE.boss
}

/**
 * @function: 小红点数字处理
 * @author: guoxt
 * @param {number} number
 */
export const overflowCount = (number) => {
  if (number > 99) {
    return '99+'
  } else {
    return number
  }
}

/**
 * @function: 时间转换
 * @author: guoxt
 * @param {string} time '2019-10-09'格式的时间字符串
 * @return {string} time '昨天'、'今天'
 */
export const timeFilter = (time) => {
  let today = transitionTimestamp(Date.now(), 'YYYY-MM-DD')
  let yesterday = transitionTimestamp(Date.now() - 24 * 60 * 60 * 1000, 'YYYY-MM-DD')
  if (time === today) {
    return '今天'
  }
  if (time === yesterday) {
    return '昨天'
  }
  return time
}

/**
 * @author lwq
 * @function 注册某个函数的after函数
 */
export const registerAfter = function (context, func, afterFn) {
  return () => {
    let res = func.apply(context, arguments)
    afterFn.apply(context, arguments)
    return res
  }
}

/**
 * @func 获取当前app版本
 * @author yanyongchao
 * @date 20190227
 */
export const clientVersion = () => {
  const ua = navigator.userAgent.toLowerCase()
  const e = ua.match(/fubei\/(\d+\.\d+\.\d+)/) || ua.match(/fubei\/(\d+\.\d+)/)
  return e ? e[1] : ''
}

/**
 * @author lwq
 * @function 对比两个版本号
 * @param {string} v1 第一个版本号
 * @param {string} v2 第二个版本号
 * @return {number} v1 > v2 返回1 v1 < v2 返回-1
 */
export const compareVersion = (v1, v2) => {
  console.log(v1, 'version', v2)
  v1 = v1.split('.')
  v2 = v2.split('.')
  let len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    let num1 = parseInt(v1[i])
    let num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
}

/**
 * @function 生成随机字符串，该字符串唯一
 * @author eleven
 * @param len {string} 所需生成字符串的长度
 */
export const getRandomString = (len = 32) => {
  let timestampStr = (new Date().getTime()).toString() // 当前时间戳
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
  var maxPos = $chars.length
  var str = ''
  for (let i = 0, length = len - 13; i < length; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return str + timestampStr
}

/**
 * @function 判断类型的函数
 * @author eleven
 * @param len {string} 变量类型
 */
export const isType = (type) => {
  return function (value) {
    let objType = Object.prototype.toString.call(value)
    let typeToUpperCase = type.replace(type[0], type[0].toUpperCase())
    console.log(objType, typeToUpperCase)
    return objType === `[object ${typeToUpperCase}]`
  }
}

/**
 * @function  店铺装修中，图片模版需要计算图片展示的形式；如果真实图片小，内容区域大，则要做宽撑满高度自适应居中，或者高度撑满，宽度自适应居中；
 * @param {string} imageSize 图片比例
 */
export const calculateBackgroundImageSize = (imageSize, imageUrl) => {
  let backgroundImageSize = {
    'background-size': '100% auto'
  }
  let showImage = new Image()
  showImage.src = imageUrl
  return new Promise((resolve, reject) => {
    showImage.onload = () => {
      console.log(showImage.width, showImage.height)
      let imageSetWidth = imageSize.split(':')[0]
      let imageSetHeight = imageSize.split(':')[1]
      let imageRealScale = showImage.width / showImage.height
      let imageSetScale = imageSetWidth / imageSetHeight
      if (imageRealScale - imageSetScale > 1) {
        backgroundImageSize = {
          'background-size': 'auto 100%'
        }
      }
      console.log(
        '计算后的背景图片：',
        imageRealScale,
        imageSetScale,
        backgroundImageSize
      )
      resolve(backgroundImageSize)
    }
  })
}

// 加
export function floatAdd (arg1, arg2) {
  var r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 减
export function floatSub (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  // 动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

// 乘
export function floatMul (arg1, arg2) {
  var m = 0

  var s1 = arg1.toString()

  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}

// 除
export function floatDiv (arg1, arg2) {
  var t1 = 0

  var t2 = 0

  var r1

  var r2
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) {}

  r1 = Number(arg1.toString().replace('.', ''))

  r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}
/**
 * @function 计算 base64 大小
 * @param {Object} base64url base64 数据字符串
 */
export const getImgSize = base64url => {
  // 获取base64图片大小，返回KB数字
  let str = base64url.replace(/data:image\/\w{3,5};base64,/, '') // 这里根据自己上传图片的格式进行相应修改
  let strLength = str.length
  let fileLength = parseInt(strLength - (strLength / 8) * 2)
  // 由字节转换为KB
  let size = ''
  size = (fileLength / 1024).toFixed(2)
  return parseInt(size)
}

/**
 * @author lwq
 * @function 设置input元素的光标的位置
 */
export const setInputSelectRange = (ctrl, pos) => {
  if (ctrl.setSelectionRange) {
    ctrl.focus()
    ctrl.setSelectionRange(pos, pos)
  } else if (ctrl.createTextRange) {
    const range = ctrl.createTextRange()
    range.collapse(true)
    range.moveEnd('character', pos)
    range.moveStart('character', pos)
    range.select()
  }
}

/**
 * 生成时间区间处理数据
 * @format {HH:00:00 ～ 次日HH:59:59}
 * @return 含正确格式的数组
 */
export const getFormatTimeDateList = () => {
  const timeRanges = []
  // 设置初始化默认选择的下标
  let defaultIndex = 0

  for (let i = 0; i <= 23; i++) {
    // 当前小时，确保是两位数
    const currentHour = i < 10 ? `0${i}` : i
    // 计算次日的结束小时，如果当前是23点，次日结束时间是22点
    const nextDayEndHour = i === 0 ? 23 : (i - 1)< 10 ? `0${(i - 1)}` : (i - 1)

    const start = `${currentHour}:00:00`

    const end = `${nextDayEndHour === 23 ? '23' : '次日' + nextDayEndHour}:59:59`

    // 推入时间范围对象
    timeRanges.push({
      start,
      end,
      content: `${start} ~ ${end}`,
      isDefault: defaultIndex === i, // 默认选中下标
      isNaturalDay: !!(`${start} ~ ${end}` === FIX_DATE_MAP.NATURAL_DAY)// 自然日
    })
  }

  console.log(timeRanges, '时间')
  return timeRanges
}

/**
 * @function 生成时间处理数据
 * @format {01:00后}
 * @return 含正确格式的数组
 */
export const getFormatDateList = () => {
  const timeRanges = []
  // 设置初始化默认选择的下标
  let defaultIndex = 11

  for (let i = 0; i <= 23; i++) {
    // 当前小时，确保是两位数
    const currentHour = i < 10 ? `0${i}` : i
    // 推入时间范围对象
    timeRanges.push(
      {
        content: `${currentHour}:00后`,
        isDefault: defaultIndex === i
      }
    )
  }
  console.log(timeRanges, '时间')
  return timeRanges
}

/**
 * @function 转换指定超出限制的字符为省略
 * @param {str} 要转换的字符串
 * @param {config} 配置项
 * @param {config.count} 指定超出多少位开始转换
 * @param {config.start} 开始截取的位置
 * @param {config.end} 结束截取的位置
 * @description {gxl门店地址测试看看吧i444巴啦啦吧 --> gxl门店地址测试看看吧...吧吧吧}
 */
export const translateString = (str, config) => {
  const { count, start, end } = config
  return str.length > Number(count)
    ? str.substring(0, Number(start)) + '...' + str.substr(Number(end))
    : str
}

/**
 * @function 特殊方式替换字符串，超出指定长度在中间添加省略号
 * @param {string} str 要处理的字符串
 * @param {object} config 配置项
 * @param {number} config.count 规定的最大字符长度
 * @param {number} [config.start] 前半部分截取长度（默认为0）
 * @param {number} [config.end] 后半部分截取长度（默认为0，即从字符串末尾开始截取）
 * @param {number} [config.strLength] 传入的字符长度，如果没有传入则计算长度
 * @return {string} 替换后的字符串
 */
export const replaceString = (str, config) => {
  const { count, start = 0, end = 0, strLength = undefined } = config
  const actualLength = strLength || calculateStringLength(str)

  // 如果实际长度小于等于count，则不需要替换
  if (actualLength <= count) {
    return str
  }

  let startLength = 0
  let endLength = 0
  let frontStr = ''
  let backStr = ''

  // 前半部分截取
  for (let i = 0; i < str.length && startLength < start; i++) {
    const char = str[i]
    if (/[\u4e00-\u9fa5]/.test(char)) {
      startLength += 2
    } else {
      startLength += 1
    }
    frontStr += char
  }

  // 后半部分截取
  for (let i = str.length - 1; i >= 0 && endLength < end; i--) {
    const char = str[i]
    if (/[\u4e00-\u9fa5]/.test(char)) {
      endLength += 2
    } else {
      endLength += 1
    }
    backStr = char + backStr
  }

  // 返回拼接后的字符串
  return frontStr + '...' + backStr
}

/**
 * @function 计算字符串的实际长度，其中汉字和特殊字符算作两个字符
 * @param {string} str 要计算的字符串
 * @return {number} 计算后的字符串长度
 */
export const calculateStringLength = (str) => {
  let length = 0
  // 遍历字符串的每个字符
  for (const char of str) {
    // 检查字符是否为汉字或特殊字符
    if (/[\u4e00-\u9fa5]+/g.test(char)) {
      // 汉字或特殊字符算作两个字符的长度
      length += 2
    } else {
      // 其他字符（字母、数字）算作一个字符的长度
      length += 1
    }
  }
  return length
}

/**
 * @function 字符串脱敏：前4后4展示，中间用*填充
 * @param {string} str - 需要脱敏的字符串（如手机号、姓名、银行卡号等）
 * @param {string} replaceChar - 替换字符，默认*
 * @returns {string} 脱敏后的字符串（长度不足4位时返回原字符串）
 */
export const desensitizeStr = (str, replaceChar = '*') => {
  // 入参校验：非字符串/空值直接返回
  if (!str || typeof str !== 'string') return str
  const len = str.length

  // 边界处理：长度≤8位（前4+后4），返回原字符串（脱敏无意义）
  if (len <= 8) return str

  // 前4位 + 后4位，中间填充*
  const prefix = str.slice(0, 4) // 前4位
  const suffix = str.slice(-4) // 后4位（slice(-4)取最后4位）
  const middle = replaceChar.repeat(len - 8) // 中间长度=总长度-8（4+4）

  return `${prefix}${middle}${suffix}`
}
